module.exports = __webpack_public_path__ + "static/media/icon-draft.169663f6.svg";